<template>
  <div class="burger-menu ml-auto" v-show="$store.state.mobile" @click="toggleSideBarMobile">
    <p><i class="fas fa-bars"></i></p>
  </div>
</template>

<script>
  export default {
    methods: {
      toggleSideBarMobile() {
        this.$store.commit("toggleSidebar");
      }
    }
  }
</script>
